import servicesSagas from 'services/sagas'

export default [servicesSagas]
